import { Link, useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { accountStrings, brandStrings, navigationStrings } from '../../content';
import { GET_MY_PROFILE } from '../../views/account/operations';
import BrandMark from '../common/BrandMark';

/**
 * Performs the avatar fallback operation.
 *
 * @param {*} value - Value to inspect or transform.
 * @returns {*} The derived operation result.
 */
function avatarFallback(value) {
  return String(value || 'H').trim().slice(0, 1).toUpperCase();
}

/**
 * Renders the navbar experience.
 *
 * @returns {JSX.Element} The rendered interface.
 */
export default function Navbar() {
  const { pathname } = useLocation();
  const { data } = useQuery(GET_MY_PROFILE);
  const profile = data?.getMyProfile;
  const displayName = profile?.displayName || '';
  /**
   * Determines whether active.
   *
   * @param {string} path - path value.
   * @returns {boolean} Whether the requested condition is satisfied.
   */
  const isActive = (path) => {
    if (path === '/') return pathname === '/' ? 'active' : '';
    return pathname === path || pathname.startsWith(`${path}/`) ? 'active' : '';
  };

  return (
    <nav className="top-nav">
      <div className="nav-left">
        <Link to="/" className="nav-brand">
          <BrandMark size="small" />
          <strong>{brandStrings.nameStart}<span>{brandStrings.nameEnd}</span></strong>
        </Link>
      </div>
      <div className="nav-center">
        <Link to="/" className={`nav-link ${isActive('/')}`}>{navigationStrings.home}</Link>
        <Link to="/hobbies" className={`nav-link ${isActive('/hobbies') || isActive('/hobby')}`}>{navigationStrings.hobbies}</Link>
        <Link to="/insights" className={`nav-link ${isActive('/insights')}`}>{navigationStrings.insights}</Link>
        <Link to="/account" className={`nav-link ${isActive('/account')}`}>{navigationStrings.account}</Link>
      </div>
      <div className="nav-right">
        <Link className="nav-profile-link" to="/account" aria-label={accountStrings.profile.openAccount}>
          {profile?.photoUrl ? <img src={profile.photoUrl} alt="" /> : <span>{avatarFallback(displayName)}</span>}
        </Link>
      </div>
    </nav>
  );
}
